export const BANNER_STATUS = {
  IN_PROGRESS: 'IN_PROGRESS',
  NEEDS_ATTENTION: 'NEEDS_ATTENTION',
  OTHER: 'OTHER'
}